import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { AirconServiceCostCalculator } from '../../../components/index/service-category/aircon-service/AirconServiceCostCalculator'
import AirconPricing from '@/index/service-category/aircon-service/AirconPricing'
import { airconCostCalculation } from 'js/aircon-cost'
import { AirconGeneralServiceProcess } from '@/index/service-category/aircon-service/AirconGeneralServiceProcess'
import ServiceWarranty from '@/index/service-category/aircon-service/ServiceWarranty'
import { AirconScope } from '@/index/service-category/aircon-service/AirconScope'
import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { RequestProvider } from 'context/RequestContext'
import AirconRequestSection from '@/index/service-category/aircon-service/AirconRequestSection'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'


// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { month, year } = getArticleDateTime()
    const modifiedDate = reviewedIso(CONTENT_REVIEWED)
    const airconBlogs = blogsMaster['hvac-services'].blogArray

    const currencyCd = "SGD"
    
    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)
    
  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        annualServicing,
        standardServicing,
        chemicalServicing,
        overhaulServicing,
        currencyCd,
        countryName
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}
export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings;
    const standardServicing = props.standardServicing
    const annualServicing = props.annualServicing
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const currencyCd = props.currencyCd
    const brandName = "LG";
    const requestType = 'Aircon Services'
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)

    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")

  return (
    <>
      <Head>
        <title>LG Air Conditioner Servicing & Repair in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="StringsSG specializes in delivering expert LG air conditioning services in Singapore. Our skilled technicians offer thorough maintenance and repair solutions for LG air conditioning units. Reach out to us for dependable and effective servicing to guarantee the optimal performance of your air conditioner."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/lg-air-conditioner" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`LG Air Conditioner Servicing & Repair in Singapore`}/>
        <meta property="og:description" content="StringsSG specializes in delivering expert LG air conditioning services in Singapore. Our skilled technicians offer thorough maintenance and repair solutions for LG air conditioning units. Reach out to us for dependable and effective servicing to guarantee the optimal performance of your air conditioner." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-09T09:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/lg-logo-png.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/lg-logo-png.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/lg-air-conditioner"/>
        <meta name="twitter:title" content={`LG Air Conditioner Servicing & Repair in Singapore`}/> 
        <meta name="twitter:description" content="StringsSG specializes in delivering expert LG air conditioning services in Singapore. Our skilled technicians offer thorough maintenance and repair solutions for LG air conditioning units. Reach out to us for dependable and effective servicing to guarantee the optimal performance of your air conditioner."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/lg-air-conditioner',
            pageName: 'LG Air Conditioner Servicing & Repair in Singapore',
            description: 'StringsSG specializes in delivering expert LG air conditioning services in Singapore. Our skilled technicians offer thorough maintenance and repair solutions for LG air conditioning units. Reach out to us for dependable and effective servicing to guarantee the optimal performance of your air conditioner.',
            serviceName: 'LG Air Conditioner Servicing & Repair Singapore',
            serviceType: 'Aircon Servicing',
            image: 'https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/lg-logo-png.png',
            datePublished: '2025-01-09T09:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'LG Air Conditioner',
          })) }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/lg-air-conditioner"/>
        </Head>
        <div>
            <RequestProvider>
                <AirconRequestSection
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    setIsQuickBook={setIsQuickBook}
                    isCustomBook={isCustomBook}
                    setIsCustomBook={setIsCustomBook}
                    requestCategorySettings={requestCategorySettings}
                    standardServicing={standardServicing}
                    chemicalServicing={chemicalServicing}
                    overhaulServicing={overhaulServicing}
                    currencyCd={currencyCd}
                    countryName={countryName}
                    requestType={requestType}
                    setIsShowJobScope={setIsShowJobScope}
                    serviceType={serviceType}
                    setServiceType={setServiceType}
                    setUnit={setUnit}
                    setUnitType={setUnitType}
                    setCost={setCost}
                    heroImage="blog/living/lg-logo-png.png"
                    title="LG Aircon Servicing Singapore"
                />
            </RequestProvider>
            <section className='max-w-5xl mx-auto py-10 px-2 space-y-8 grid md:grid-cols-2 gap-5 items-center'>
                <div className='space-y-8'>
                    <h1 className='text-3xl md:text-4xl font-semibold text-center'>Trusted LG Aircon Servicing & Repair in Singapore</h1>
                    <p className='leading-8 text-center'>
                        StringsSG provides professional LG air conditioner servicing in Singapore. Our seasoned technicians deliver thorough maintenance and repair services for 
                        LG air conditioning units. Submit a request for dependable and efficient servicing to ensure the optimal performance of your LG air conditioner.
                    </p>
                </div>
                <div className='relative flex justify-center max-w-md mx-auto'>
                    <Image className='rounded-lg'
                            src={s3Static + "blog/living/lg-logo-png.png"}
                            height={270}
                            width={300}
                            style={{objectFit: 'contain', width: '300px', height: '270px'}}
                            alt='LG Aircon Servicing '
                    />          
                </div>
            </section>
            <AirconPricing
                standardServicing={standardServicing} 
                annualServicing={annualServicing} 
                chemicalServicing={chemicalServicing} 
                overhaulServicing={overhaulServicing} 
                gasTopup={[{type: 'R22', priceRange: 'S$40 - S$100'}, {type: 'R410A', priceRange: 'S$90 - S$150'}, {type: 'R32', priceRange: 'S$120 - S$220'}]}  
                currencyCd={currencyCd}
            />
            <section className='py-5 bg-slate-600'>
                <div className='max-w-2xl mx-auto text-center text-white py-5 space-y-4 px-2'>   
                    <h2 className='text-2xl font-bold'>LG Aircon Servicing Cost Calculator</h2>                
                    <p className='leading-7'>Use this calculator to get an estimation of how much you should be paying for LG Aircon Servicing in Singapore.</p>                       
                </div>
                <AirconServiceCostCalculator requestCategorySettings={requestCategorySettings}/>
            </section>
            <section className='max-w-5xl mx-auto py-10'>
                <AirconGeneralServiceProcess />
            </section> 
            <ServiceWarranty brand={brandName} />            
            <section className="max-w-5xl mx-auto py-12 px-4 space-y-12">
                <header className="text-center space-y-3">
                    <h2 className="text-3xl md:text-4xl font-bold">LG Air Conditioner Models in Singapore</h2>
                    <p className="text-lg md:text-xl max-w-2xl mx-auto">
                    Discover the latest LG aircon systems available for residential use. Expert installation and servicing by StringsSG.
                    </p>
                </header>

                <div className="space-y-6">
                    <p className="leading-7">
                    At <strong>StringsSG</strong>, we specialize in the servicing and installation of LG air conditioning systems, including single-split and multi-split inverters. 
                    Our certified technicians are trained to handle all LG AC models with efficiency and care.
                    </p>
                    <div className="relative h-96 w-full rounded-xl overflow-hidden shadow-lg">
                    <Image
                        src={s3Static + "blog/living/lg-aircon.png"}
                        alt="Modern LG Air Conditioner in Living Room"
                        fill
                        style={{ objectFit: 'cover' }}
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                    </div>
                </div>

                <section className="space-y-8">
                    <div className="grid md:grid-cols-2 gap-6">
                    {[
                        {
                        title: "Artcool Multi Split Inverter A/C (ThinQ)",
                        image: "lg-single-split-inverter-Artcool.png",
                        alt: "LG Artcool Multi Split Inverter Aircon",
                        description:
                            "The LG Artcool features an advanced auto-cleaning system that dries and sterilizes the interior, preventing bacteria and mold buildup for a healthier indoor environment.",
                        },
                        {
                        title: "LG Dualcool Single Split Smart Inverter (ThinQ, R32)",
                        image: "lg-single-split-inverter-12000-btu.png",
                        alt: "LG Dualcool Smart Inverter Aircon 12,000 BTU",
                        description:
                            "The LG Dualcool inverter (US-Q242K) cools up to 40% faster than standard models. Enjoy rapid, efficient cooling with R32 refrigerant and smart ThinQ connectivity.",
                        },
                        {
                        title: "LG 18K BTU Multi Split Inverter System 3 R32",
                        image: "lg-multi-split-inverter-3-system.png",
                        alt: "LG Multi Split Inverter System 3 (18K BTU)",
                        description:
                            "Equipped with a BLDC compressor and pressure sensors, this system offers outstanding energy efficiency, reliability, and long-term cost savings.",
                        },
                        {
                        title: "LG 28K BTU Multi Split Inverter System 4 R32",
                        image: "lg-multi-split-inverter-4-system.png",
                        alt: "LG Multi Split Inverter System 4 (28K BTU)",
                        description:
                            "Faster cooling, quieter operation, and a more compact design make this LG system ideal for Singapore homes seeking efficiency and comfort.",
                        },
                    ].map(({ title, image, alt, description }) => (
                        <article
                        key={title}
                        className="border shadow-md rounded-xl overflow-hidden p-4 bg-white hover:shadow-xl transition duration-300"
                        >
                        <h3 className="text-lg md:text-xl font-bold text-center mb-4">{title}</h3>
                        <div className="relative h-72 w-full mb-4">
                            <Image
                            src={s3Static + `blog/living/${image}`}
                            alt={alt}
                            fill
                            style={{ objectFit: 'contain' }}
                            placeholder="blur"
                            blurDataURL={s3Static + "placeholder.png"}
                            sizes="(max-width: 768px) 100vw, 33vw"
                            />
                        </div>
                        <p className="text-sm md:text-base leading-relaxed">{description}</p>
                        </article>
                    ))}
                    </div>
                </section>

                <section className="space-y-6">
                    <h3 className="text-xl md:text-2xl font-semibold text-center uppercase text-amber-800">New LG Aircon Price Range</h3>
                    <p className="max-w-4xl mx-auto text-center leading-7">
                    Thinking of upgrading your home with an LG air conditioner? We offer competitive prices tailored to your space and needs. 
                    Costs vary depending on the model, cooling capacity, and installation complexity. Contact us today for a custom quote.
                    </p>
                </section>

                <section className="space-y-6">
                    <h3 className="text-xl md:text-2xl font-semibold text-center uppercase text-amber-800">Manufacturer Warranty Coverage</h3>
                    <p className="max-w-4xl mx-auto text-center leading-7">
                    All new LG air conditioning systems come with a manufacturer warranty ranging from 1 to 5 years. Our team will guide you 
                    through the specific coverage details for your selected model to ensure peace of mind and protection.
                    </p>
                </section>
            </section>
            <section className="py-12 px-4 max-w-5xl mx-auto space-y-8 text-gray-800">
                <header className="text-center">
                    <h2 className="text-3xl md:text-4xl font-bold uppercase mb-2">
                    Common LG Aircon Error Codes & Problems
                    </h2>
                    <p className="text-md md:text-lg max-w-3xl mx-auto leading-7">
                    LG air conditioners may experience issues that trigger specific error codes. Understanding these codes can help you quickly identify and resolve problems with your unit.
                    </p>
                </header>

                <article className="space-y-5">
                    <h3 className="text-xl font-semibold text-gray-900">Typical LG Air Conditioner Problems</h3>
                    <ul className="list-disc pl-5 space-y-1 text-gray-700 leading-7">
                    <li>Insufficient cooling or weak airflow</li>
                    <li>Unusual noises or vibrations during operation</li>
                    <li>Water leakage or dripping indoors</li>
                    <li>Sensor or control board malfunctions</li>
                    <li>Compressor or outdoor fan motor failure</li>
                    </ul>
                </article>

                <article className="space-y-5">
                    <h3 className="text-xl font-semibold text-gray-900 pt-4">Common LG Aircon Error Codes Explained</h3>
                    <p className="leading-7">
                    LG air conditioners display error codes to help diagnose issues with specific components. Below are common LG &quot;CH&quot; error codes and their meanings:
                    </p>

                    <div className="overflow-x-auto">
                    <table className="w-full border border-slate-300 text-sm text-left table-auto">
                        <thead className="bg-amber-100 text-amber-700 font-medium">
                        <tr>
                            <th className="border border-slate-300 px-3 py-2 text-center">Error Code</th>
                            <th className="border border-slate-300 px-3 py-2">Possible Cause</th>
                            <th className="border border-slate-300 px-3 py-2">Recommended Solution</th>
                        </tr>
                        </thead>
                        <tbody className="text-gray-700">
                        {[
                            {
                            code: "CH 01",
                            cause: "Communication failure between indoor and outdoor units.",
                            solution: "Inspect and secure all wiring connections between units.",
                            },
                            {
                            code: "CH 02",
                            cause: "Indoor temperature sensor is malfunctioning.",
                            solution: "Replace the defective temperature sensor.",
                            },
                            {
                            code: "CH 24",
                            cause: "Faulty heat exchanger temperature sensor.",
                            solution: "Replace the indoor or outdoor heat exchanger sensor.",
                            },
                            {
                            code: "CH 26",
                            cause: "Water leakage detected from the drain pan.",
                            solution: "Check for blocked drain pipes and clean if necessary.",
                            },
                            {
                            code: "CH 67",
                            cause: "Malfunctioning outdoor fan motor.",
                            solution: "Replace the damaged fan motor with a new one.",
                            },
                        ].map(({ code, cause, solution }) => (
                            <tr key={code} className="even:bg-slate-50">
                            <td className="border border-slate-300 px-3 py-2 text-center text-amber-700 font-semibold">{code}</td>
                            <td className="border border-slate-300 px-3 py-2">{cause}</td>
                            <td className="border border-slate-300 px-3 py-2">{solution}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>

                    <p className="text-gray-600 leading-7">
                    Please note: These error codes may vary depending on your LG aircon model. If you&apos;re experiencing any of the above issues, our experienced technicians at StringsSG can perform a detailed diagnostic and provide quick, professional repairs.
                    </p>
                </article>
            </section>
            <BlogsList blogs={airconBlogs}/>
        </div>
        {isShowJobScope &&
            <AnimatePresence>
                <AirconScope 
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType} 
                unit={unit} 
                unitType={unitType} 
                cost={cost} />
            </AnimatePresence>
        }
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
